import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSchemaViewerBlank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="schema-viewer-blank_svg__Blank"
    x={0}
    y={0}
    width={24}
    height={17}
    xmlSpace="preserve"
    role="img"
    {...props}
  />
);
const Memo = memo(SvgSchemaViewerBlank);
export default Memo;
